import { HashRouter, Route, Routes } from 'react-router-dom';

import { useState } from 'react';
import MenuLayout from './components/layouts/MenuLayout';
import { AppProvider } from './context/ContextProvider';
import useAsyncEffect from './hooks/useAsyncEffect';
import { Session } from './types/Session';
// import NoneLayout from './components/layouts/NoneLayout';
import '@mdxeditor/editor/style.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TranslateProvider } from 'sbx-crm-menu-ui';
import sbxEvent from './classes/SbxEvent';
import NoneLayout from './components/layouts/NoneLayout';
import { HomePageComponent } from './components/pages/HomePageComponent';
import AgentListComponent from './components/pages/ai-agent-v2/AgentListComponent';
import AgentSetupComponent from './components/pages/ai-agent-v2/AgentSetupComponent';
import { AgentDetailPageComponent } from './components/pages/ai-agent/AgentDetailPageComponent';
import { AgentListPageComponent } from './components/pages/ai-agent/AgentListPageComponent';
import { BotScript } from './components/pages/bot-script/BotScript';
import { DocumentDetailPageComponent } from './components/pages/documents/DocumentDetailPageComponent';
import { DocumentListPageComponent } from './components/pages/documents/DocumentListPageComponent';
import DocumentPageComponent from './components/pages/documentsV2/DocumentPageComponent';
import AnalizeDocumentComponent from './components/pages/documentsV3/AnalizeDocumentComponent';
import DocumentListComponentV2 from './components/pages/documentsV3/DocumentListComponentV2';
import { ImagesPageComponent } from './components/pages/images/ImagesPageComponent';
import AnalizeImagesComponent from './components/pages/imagesV2/AnalizeImagesComponent';
import ImagesListComponentV2 from './components/pages/imagesV2/ImagesListComponentV2';
import MarkdownChatComponent from './components/pages/mark-down/chat/MarkdownChatComponent';
import MarketingAgentListComponentV2 from './components/pages/marketing-agent-v2/MarketingAgentListComponentV2';
import QuestionMarketingAgentComponentV2 from './components/pages/marketing-agent-v2/QuestionMarketingAgentComponentV2';
import { MarketingAgentPageComponent } from './components/pages/marketing-agent/MarketingAgentPageComponent';
import SpeechToTextListComponentV2 from './components/pages/speech-to-text-v3/SpeechToTextListComponentV2';
import TranscriptionSpeechToTextComponentV2 from './components/pages/speech-to-text-v3/TranscriptionSpeechToTextComponentV2';
import SpeechListComponent from './components/pages/speech-to-text/SpeechListComponent';
import SpeechToTextComponent from './components/pages/speech-to-text/SpeechToTextComponent';
import { LoadingComponent } from './components/shared/LoadingComponent';
import Permission from './components/shared/Permission';
import { ValidationInactivityWrapper } from './components/shared/ValidationInactivityWrapper';
import { Toaster } from './components/ui/sonner';
import en from './dictionaries/en.json';
import es from './dictionaries/es.json';
import nl from './dictionaries/nl.json';
import { verifySessionService } from './services/AuthService';
import { Permissions } from './types/Permission';
import sessionActions from './types/SessionActions';
import { mergeObjects } from './utils';
import { version } from './utils/version';
import AgentListV3Component from './components/pages/ai-agent-v3/AgentListV3Component';
import AgentSetupV3Component from './components/pages/ai-agent-v3/AgentSetupV3Component';

const routes = [
    {
        path: '/',
        component: HomePageComponent,
        label: 'Web View',
        layout: MenuLayout,
    },
    {
        path: '/agent',
        component: AgentListPageComponent,
        label: 'Agent List',
        layout: MenuLayout,
    },
    {
        path: '/agent_setup/:id',
        component: AgentSetupComponent,
        label: 'Agent Setup',
        layout: MenuLayout,
    },
    {
        path: '/agent_setup_v3/:id',
        component: AgentSetupV3Component,
        label: 'Agent Setup V3',
        layout: MenuLayout,
    },
    {
        path: '/agent_list',
        component: AgentListComponent,
        label: 'Agent List',
        layout: MenuLayout,
    },
    {
        path: '/agent_list_v3',
        component: AgentListV3Component,
        label: 'Agent List V3',
        layout: MenuLayout,
    },
    {
        path: '/agent_detail/create',
        component: AgentDetailPageComponent,
        label: 'Agent Detail',
        layout: MenuLayout,
    },
    {
        path: '/agent_detail/:id',
        component: AgentDetailPageComponent,
        label: 'Agent Detail',
        layout: MenuLayout,
    },
    {
        path: '/document',
        component: DocumentListPageComponent,
        label: 'Document List',
        layout: MenuLayout,
    },
    // {
    //   path: '/document_detail/create',
    //   component: DocumentDetailPageComponent,
    //   label: 'Document Detail',
    //   layout: MenuLayout,
    // },
    {
        path: '/document_detail_v2/:id',
        component: DocumentPageComponent,
        label: 'Document Detail',
        layout: MenuLayout,
    },
    {
        path: '/document_detail/:id',
        component: DocumentDetailPageComponent,
        label: 'Document Detail',
        layout: MenuLayout,
    },
    {
        path: '/speech-to-text/:job_id',
        component: SpeechToTextComponent,
        label: 'Speech to text',
        layout: MenuLayout,
    },
    {
        path: '/speech-to-text/list',
        component: SpeechListComponent,
        label: 'Speech to text',
        layout: MenuLayout,
    },
    {
        path: '/speech-to-text-v2/transcribe',
        component: TranscriptionSpeechToTextComponentV2,
        label: 'Speech to text',
        layout: MenuLayout,
    },
    {
        path: '/speech-to-text-v2/list',
        component: SpeechToTextListComponentV2,
        label: 'Speech to text',
        layout: MenuLayout,
    },
    {
        path: '/images',
        component: ImagesPageComponent,
        label: 'Images',
        layout: MenuLayout,
    },
    {
        path: '/marketing-agent',
        component: MarketingAgentPageComponent,
        label: 'Marketing Agent',
        layout: MenuLayout,
    },
    {
        path: '/marketing-agent-v2/list',
        component: MarketingAgentListComponentV2,
        label: 'Marketing Agent',
        layout: MenuLayout,
    },
    {
        path: '/marketing-agent-v2/ask-question',
        component: QuestionMarketingAgentComponentV2,
        label: 'Marketing Agent',
        layout: MenuLayout,
    },
    {
        path: '/documents-v2',
        component: DocumentListComponentV2,
        label: 'Document List',
        layout: MenuLayout,
    },
    {
        path: '/documents-v2/analyze-document',
        component: AnalizeDocumentComponent,
        label: 'Analize Document',
        layout: MenuLayout,
    },
    {
        path: '/images-v2',
        component: ImagesListComponentV2,
        label: 'Document List',
        layout: MenuLayout,
    },
    {
        path: '/images-v2/analyze-images',
        component: AnalizeImagesComponent,
        label: 'Analize Document',
        layout: MenuLayout,
    },
    {
        path: '/bot-script/:id',
        component: BotScript,
        label: 'Bot Script',
        layout: NoneLayout,
    },
    {
        path: '/mark-down/chat/:agentId',
        component: MarkdownChatComponent,
        label: 'Chat',
        layout: NoneLayout,
    },
];

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 3,
            refetchOnWindowFocus: false,
        },
    },
});

export const useSearchParams = () => {
    const [searchParams] = useState(() => {
        return new URLSearchParams(window.location.href.popOfSplit('?'));
    });

    return searchParams;
};

const AI_STUDIO_AGENT_V2 = Permissions.SBX_STUDIO_AGENT_V2;
const AI_STUDIO_AGENT_V3 = Permissions.SBX_STUDIO_AGENT_V3;

export function removeTokenAndReload() {
    localStorage.removeItem('crm_token');
    window.location.href = window.location.origin;
}

export default function App() {
    const [sessionExist, setSessionExist] = useState<Session>();
    const [languages, setLanguages] = useState<Record<string, Record<string, Record<string, string>>>>({});

    const searchParams = useSearchParams();

    useAsyncEffect(async () => {
        const preview_mark_down_token = searchParams.get('preview_mark_down_token');
        if (preview_mark_down_token) {
            sessionActions.setToken(preview_mark_down_token as string);
        }
        const response = await verifySessionService();
        console.log('version', version);

        if (preview_mark_down_token && !response.success) {
            sessionActions.reload();
        }

        if (response.success) {
            setSessionExist(response.item);

            if (!localStorage.getItem('crm_locale')) {
                localStorage.setItem('crm_locale', response.item.defaultLocale);
            }
            sbxEvent.setSbxCrm(response.item.user_key);
            const initialData = response.item.languages;
            const dataArray = [initialData, { en, es, nl }];
            const combinedData = dataArray.reduce((accumulator, current) => mergeObjects(accumulator, current), {});

            setLanguages(combinedData);
        } else {
            removeTokenAndReload();
        }
    }, []);

    if (sessionExist) {
        return (
            <TranslateProvider
                locale={localStorage.getItem('crm_locale') || sessionExist.defaultLocale || 'es'}
                translations={languages}
            >
                <QueryClientProvider client={queryClient}>
                    <AppProvider session={sessionExist}>
                        <Permission
                            permission={[AI_STUDIO_AGENT_V2, AI_STUDIO_AGENT_V3]}
                            denied={<DeniedComponent vh100 />}
                        >
                            <ValidationInactivityWrapper>
                                <>
                                    <Toaster richColors />

                                    <HashRouter>
                                        <Routes>
                                            {routes.map((route, index) => (
                                                <Route
                                                    key={index}
                                                    path={route.path}
                                                    element={
                                                        <route.layout>
                                                            <route.component />
                                                        </route.layout>
                                                    }
                                                />
                                            ))}
                                        </Routes>
                                    </HashRouter>
                                </>
                            </ValidationInactivityWrapper>
                        </Permission>
                    </AppProvider>
                </QueryClientProvider>
            </TranslateProvider>
        );
    }

    return <LoadingComponent />;
}

export function DeniedComponent({ vh100 }: { vh100?: boolean }) {
    const text =
        localStorage.getItem('crm_locale') === 'es'
            ? 'No tienes los permisos necesarios para acceder a esta página'
            : 'You do not have the necessary permissions to access this page';

    return (
        <div className={`flex justify-center items-center w-full ${vh100 ? ' h-[100vh]' : 'h-[calc(100vh-80px)]'}`}>
            <h1 className="text-2xl font-bold text-gray-400">{text}</h1>
        </div>
    );
}
